"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var types_1 = require("../types");
var useFinalizing = function (_a) {
    var auctionType = _a.auctionType, lotLocale = _a.lotLocale;
    var _b = (0, react_1.useState)(false), validating = _b[0], setValidating = _b[1];
    var finalizingText = (0, react_1.useMemo)(function () {
        if (auctionType === types_1.AuctionTypeEnum.Timed)
            return "Checking all bids... Please wait";
        else if (auctionType === types_1.AuctionTypeEnum.Tender)
            return "Checking all tenders... Please wait";
        return "Validating ".concat(lotLocale.toLowerCase(), " status... Please wait");
    }, [lotLocale, auctionType]);
    return { finalizingText: finalizingText, validating: validating, setValidating: setValidating };
};
exports.default = useFinalizing;
